import { Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

import { LogService } from './';
import { Port, Vessel, Carrier } from './models';
import { Trips } from './models/trip-models/trips';

@Injectable()
export class SeoService {

  constructor(private logger: LogService, private titleService: Title, private metaService: Meta) {
  }

  // https://github.com/angular/angular/blob/4.0.0-beta.6/modules/%40angular/platform-browser/src/browser/meta.ts

  // for examples
  // https://github.com/angular/angular/commit/72361fb68f79fbddac96cc4c005eac85f071692a

  setPort(port: Port): void {
    let title = `${port.name} Port Vessel Schedule - Linescape`;

    this.titleService.setTitle(title);

    let description = `View cargo vessel arrivals and departures for the port of ${port.display}. Filter schedule data by date and carrier, or search nearby port schedules.`;

    this.metaService.updateTag({ name: 'description', content: description }, 'description');
  }

  setVessel(vessel: Vessel): void {
    let title = `${vessel.name} Vessel Sailing Schedule - Linescape`;

    this.titleService.setTitle(title);

    let description = `View ${vessel.name} IMO: ${vessel.imo} container ship sailing schedules, along with vessel capacity, propulsion, and construction data.`;

    this.metaService.updateTag({ name: 'description', content: description }, 'description');
  }

  setCarrier(carrier: Carrier): void {
    let title = `${carrier.name} Schedule - ${carrier.name} Vessels - Linescape`;

    this.titleService.setTitle(title);

    let description = `View sailing schedules and vessels data for carrier ${carrier.name} - ${carrier.description} and access ${carrier.name} local office contact information by country.`;

    this.metaService.updateTag({ name: 'description', content: description }, 'description');
  }

  setTrips(trips: Trips): void {
    // let origin = trips.originPorts[0].port.name; // not precise
    // let destination = trips.destinationPorts[0].port.name; // not precise
    let title = 'Schedules - Linescape';

    this.titleService.setTitle(title);
  }

  set(title: string, description: string) {
    this.titleService.setTitle(title);

    this.metaService.updateTag({ name: 'description', content: description }, 'description');
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/seo.service.ts